import { Box, Button, Grid, Paper, Typography, Link } from "@mui/material";
import loginBG from "../assets/images/login_background.png";
import Logo from "../components/common/Logo";
import Notification from "../components/common/notification/Notification";
import { signupFormFields } from "../components/signup/signupFormFields";
import FormField from "../components/common/FormField";
import React, { FormEvent, useEffect, useState } from "react";
import Validation from "../utils/Validation";
import { useDispatch } from "react-redux";
import {
  OtpVerifyAction,
  resendOtpAction,
  setOtpVerifyAction,
  setResendOtpAction,
} from "../store/reducers/adminCreationSlice";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserAction, setLogoutAction, setUserAction } from "../store/reducers/userSlice";

interface FormElement {
  id: string;
  label?: string;
  placeholder: string;
  type: string;
  isRequired?: boolean;
  autocomplete?: string;
  inputProps?: any;
}

const formElements: FormElement[] = [
  {
    id: "username",
    label: "",
    placeholder: "Enter User Name",
    type: "text",
    isRequired: true,
    autocomplete: "off",
    inputProps: {
      disabled: true,
    },
  },
  // {
  //   id: "email",
  //   label: "",
  //   placeholder: "Enter Email ID",
  //   type: "text",
  //   isRequired: true,
  //   autocomplete: "off",
  //   inputProps: {
  //     disabled: true,
  //   },
  // },

  {
    id: "otp",
    label: "",
    placeholder: "Enter Verification Code",
    type: "text",
    isRequired: true,
    autocomplete: "off",
  },
];

const AccountVerify: React.FC = () => {
  const dispatch = useDispatch();
  const { isOtpVerifyResponseSuccess, isResetOtpResponseSuccess } = useSelector(
    (state: any) => state.adminCreation
  );
  const { user } = useSelector((state: any) => state?.user);
  const navigate = useNavigate();
  const [formData, setFormData]: any = useState({
    username: localStorage.getItem("userName")
      ? JSON.parse(localStorage.getItem("userName") as string)
      : "",
    email: localStorage.getItem("userEmail")
      ? JSON.parse(localStorage.getItem("userEmail") as string)
      : "",
    otp: "",
  });
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [timer, setTimer] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    username: formData?.username,
    // email: formData?.email,
    otp: formData?.otp,
  });

  useEffect(() => {
    if (isResendDisabled) {
      const interval = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            setIsResendDisabled(false);
            return 60;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isResendDisabled]);

  useEffect(() => {
    console.log("user", user);
    if (user?.idToken) {
      // Only allow redirect if is_password_change_required key exists and is false, or key does not exist
      if (
        user?.user?.email_verified === "true" &&
        (user?.user?.hasOwnProperty("is_password_change_required")
          ? user?.user?.is_password_change_required === false
          : true)
      ) {
        if(user?.user?.email_verified ==="true" && user?.nextAction !==""){
          navigate("/plans");
        }else{
          if (user?.user?.roles.includes("TENANT") || user?.user?.roles.includes("Owner") || user?.user?.roles.includes("Admin")) {
            if (user?.user?.is_new) {
              navigate("/settings");
            } else {
              navigate("/dashboard");
            }
          } else {
            navigate("/dashboard");
          }
        }
      } else {
        navigate("/activate");
      }
    }
  }, [user?.idToken]);

  const handleGoToLogin = () => {
    localStorage.clear(); // Clear all local storage data
    // localStorage.removeItem("user");
    dispatch(setUserAction(null)); // Clear user state in Redux
    navigate("/");
  };

  const onChangeAction = (e: any) => {
    const id = e?.target?.id;
    const value = e?.target?.value;
    setFormData({
      ...formData,
      [id]: value,
    });
    resetValidator(e.target.id);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        setIsActionCalled(false);
        dispatch(OtpVerifyAction(formData));
      } else {
        setIsActionCalled(false);
      }
    }
  }, [isActionCalled]);

  useEffect(() => {
    if (isOtpVerifyResponseSuccess) {
      setTimeout(()=>{

        dispatch(
          getUserAction({
            isToLogoutAllDevices:false,
            usernameOrEmail: formData?.username,
            password: localStorage.getItem("password")
              ? JSON.parse(localStorage.getItem("password") as string)
              : "",
          })
        );
      },2000)
      dispatch(setOtpVerifyAction(false));
      // navigate("/plans");
    }
  }, [isOtpVerifyResponseSuccess]);

  const handleResendOTP = () => {
    console.log("Resending OTP...");

    dispatch(resendOtpAction(formData));
    // Call API to resend OTP here
  };

  useEffect(() => {
    if (isResetOtpResponseSuccess) {
      setIsResendDisabled(true);
      setTimer(60);
      dispatch(setResendOtpAction(false));
    }
  }, [isResetOtpResponseSuccess]);
  return (
    <>
      <Grid
        container
        component="main"
        sx={{
          height: "100vh",
          justifyContent: "center", // Center horizontally
          alignItems: "center", // Center vertically
          position: "relative",
          zIndex: 1, // Ensure content is above the background image
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${loginBG})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 1, // Set the opacity of the background image
            zIndex: -1, // Place the background image behind the content
          },
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          component={Paper}
          // elevation={6}
          square
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Center vertically
            alignItems: "center", // Center horizontally
            width: "100%",
            "max-width": "100%",
            backgroundColor: "rgba(255, 255, 255, 0.50)",
            padding: "16px 0px",
            borderRadius: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: { xs: "0px 16px", sm: "0px" },
              width: "80%",
            }}
          >
            <Logo isTitle={true} isPosition={true} />
            <Typography
              variant="h1"
              fontWeight={600}
              align="center"
              sx={{
                fontSize: { xs: "1.5rem", sm: "2.5rem" },
                color: "#000000",
                padding: "16px 0px",
              }}
            >
              OTP Verification
            </Typography>
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{
                mt: 1,
                // display: "ruby",
                // justifyContent: "center", // Center children horizontally
                // flexDirection: "column", // Align children vertically
                // alignItems: "center",
                // width: '70%'
                width: "100%",
              }}
            >
              <Notification />
              {formElements?.map((field, index) => {
                return (
                  <FormField
                    {...{
                      ...field,
                      ...{
                        variant: "outlined",
                        isRounded: true,
                        onChange: onChangeAction,
                        onBlur: onBlurAction,
                        sx: {
                          marginTop: "0px !important",
                          "& input:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 1000px #fff inset",
                            WebkitTextFillColor: "#000",
                            background: "transparent",
                            height: "auto !important",
                            marginTop: "0px !important",
                          },
                        },
                        InputProps: {
                          ...(field?.inputProps && field?.inputProps),
                        },

                        error: error && error[field?.id],
                        value: formData ? formData[field?.id] : "",
                        helperText:
                          field?.id === "proposedPassword"
                            ? error &&
                              "Use at least 8 characters, one uppercase letter, one lowercase letter, one special character and one number in your password"
                            : error && error[field?.id],
                      },
                    }}
                  />
                );
              })}
              <span style={{ display: "flex", justifyContent: "flex-end" }}>
                <Typography onClick={handleGoToLogin}
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    textDecoration: "none",
                    fontWeight: 600,
                    marginRight: 2,
                    letterSpacing: 0.5,
                    width: "fit-content",cursor:'pointer'
                  }}
                
                >
                  Go To Login
                </Typography>
              </span>
              <div style={{ textAlign: "center" }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    fontWeight: 600,
                    fontSize: "18px",
                    mt: 3,
                    mb: 2,
                    width: "160px", // Adjust the width as needed
                    borderRadius: "20px", // Set a border radius for rounding
                    padding: "10px 16px",
                    textTransform: "none !important",
                    backgroundColor: "#076C6B",
                    letterSpacing: 1.5,
                  }}
                >
                  Submit
                </Button>
                {/* Resend OTP Button */}
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <Button
                    variant="text"
                    onClick={handleResendOTP}
                    disabled={isResendDisabled}
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      textTransform: "none",
                      letterSpacing: 1.2,
                      color: isResendDisabled ? "#fff" : "#076C6B",
                    }}
                  >
                    {isResendDisabled
                      ? `Resend OTP in ${timer}s`
                      : "Resend OTP"}
                  </Button>
                </div>
              </div>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default AccountVerify;
